import { Component } from 'react';
import IdealContact from './IdealContact';

interface ErrorBoundaryProps {
  children: JSX.Element;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { state, props } = this;

    if (state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen min-w-screen flex">
          <div className="w-11/2 max-w-180 bg-blue-100 p-4 rounded-xl text-neutral-800 m-auto">
            <h1 className="mb-3">
              An unexpected error has occurred. Please try refreshing the page.
              If you are using an older browser, please try updating to the
              latest version. If the problem persists, try reaching out to us
              at:
            </h1>
            <IdealContact />
          </div>
        </div>
      );
    }

    const { children } = props;

    return children;
  }
}

export default ErrorBoundary;
